import { render } from "./ReportManage.vue?vue&type=template&id=50bf9695"
import script from "./ReportManage.vue?vue&type=script&lang=js"
export * from "./ReportManage.vue?vue&type=script&lang=js"

import "./ReportManage.vue?vue&type=style&index=0&id=50bf9695&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__